import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./cancleAppointmentPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { ITreatmentPlan } from "../../../types/types";
import { useAppSelector } from "../../../services/hooks";
import { userSelector } from "../../../services/selectors/user.selectors";
import {
  getPrintDate,
  isDateAfterToday,
  replaceVariables,
} from "../../../utils/utils";
import { useAlternativeAppointmentProgramDateMutation } from "../../../services/api/user.api";
import { TAppointment } from "../../../services/types/user.types";
import { useState } from "react";
import Modal from "../modal/Modal";
import CancleCalenderPopup from "../cancleCalenderPopup/cancleCalenderPopup";

interface ICancleAppointmentPopupProps {
  onClose: () => void;
  onFullClose: () => void;
  onError: () => void;
  setProgramDates: (programDatesChanged: TAppointment[] | null) => void;
  onSuccess: (change: boolean, date: string) => void;
  date: string;
  treatmentPlan: ITreatmentPlan;
}

function CancleAppointmentPopup({
  onClose,
  date,
  treatmentPlan,
  setProgramDates,
  onSuccess,
  onError,
}: ICancleAppointmentPopupProps) {
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const therapist = useAppSelector(userSelector);

  const [day, month, year] = date.split("/").map(Number);

  const isAfterToday = isDateAfterToday(new Date(year, month - 1, day));

  const [findAlternativeMeeting, isLoading] =
    useAlternativeAppointmentProgramDateMutation();

  const openCancelCalendarPopup = () => {
    setOpenCalendar(true);
  };

  const AlternativeMeeting = () => {
    const dateToDelete = date
      .split("/")
      .reverse()
      .map((val, idx) => (idx === 1 ? +val - 1 : +val))
      .reduce((d, val, idx) => {
        (d as any)[`set${["FullYear", "Month", "Date"][idx]}`](val);
        return d;
      }, new Date(0))
      .toDateString()
      .replace("T00:00:00.000Z", "T00:00:00");
    const { usersId, therapistsId, ...restAppointmentsProgram } =
      treatmentPlan.appointmentsProgram;

    findAlternativeMeeting({
      ...restAppointmentsProgram,
      dateToDelete: dateToDelete,
      deleteType: 2,
      updateUsersGuid: therapist.guid,
    }).then((res) => {
      if ("data" in res) {
        setProgramDates(res.data);
        onClose();
        let maxIndex = res.data.reduce(
          (maxIdx, obj, idx, array) =>
            obj.id > array[maxIdx].id ? idx : maxIdx,
          0
        );
        // eslint-disable-next-line array-callback-return
        onSuccess(
          true,
          getPrintDate(new Date(res.data[maxIndex].appointmentDate))
        );
      } else {
        // console.error(res);
      }
    });
  };
  return (
    <article style={{ placeItems: "center" }} className={popupStyles.popup}>
      <img src={doctor} alt={t("ALTERNATIVE_APPOINTMENT_POPUP_IMAGE_ALT")} />
      <p className={popupStyles.popup__text}>
        {t("GREETING", { firstName: therapist.firstName })}
      </p>
      <p className={popupStyles.popup__title}>
        {t("CANCEL_SESSION_INTRO", {
          gender: replaceVariables("@gender", therapist),
        })}
      </p>
      <p className={popupStyles.popup__text}>{date}</p>
      <p
        className={`${popupStyles.popup__title} ${
          !isAfterToday && popupStyles.popup__nextBtn_cisabled
        }`}
      >
        {t("CANCEL_APPOINTMENT_MEETING_PROMPT")}
      </p>
      <button
        className={`${popupStyles.popup__nextBtn} ${
          !isAfterToday && popupStyles.popup__nextBtn_cisabled
        }`}
        onClick={AlternativeMeeting}
        disabled={isLoading.isLoading || !isAfterToday}
      >
        {t("CANCEL_APPOINTMENT_CONFIRM_BUTTON")}
      </button>
      <button
        className={`button ${popupStyles.popup__nextBtn} ${popupStyles.popup__nextBtn_white}`}
        onClick={() => {
          openCancelCalendarPopup();
        }}
      >
        {isAfterToday ? t("NO") : ""} {t("GO_TO_CALENDAR")}
      </button>
      <h4 className={popupStyles.popup__title}>
        {t("CANCEL_APPOINTMENT_WARNING")}
      </h4>
      {openCalendar && (
        <Modal prevencherAnswer onClose={() => setOpenCalendar(false)}>
          <CancleCalenderPopup
            treatmentPlan={treatmentPlan}
            setProgramDates={setProgramDates}
            date={date}
            onError={onError}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        </Modal>
      )}
    </article>
  );
}

export default CancleAppointmentPopup;
